import axios from 'axios';
import { IUserShort, IUserShortCollection } from 'common/models';
import {
  IContract,
  IContractCollection,
  IContractListParams,
  ICreateContractPayload,
  IDeleteContractPayload,
  IUpdateContractPayload,
  IContractUserListParams,
  ICreateContractUserPayload,
  IDeleteContractUserPayload,
  IContractSyncStatus,
  IContractSyncStatusParams,
  IUpdateContractGoodsAvailabilityPayload,
  IContractGoodsSettingsParams,
  IContractGoodsSettings,
  IUnsetContractGoodsSettingsPayload,
  IUnsetContractManualSettingsPayload,
} from 'entities/Contract/Contract.models';

const basePath = 'contract';

export const contractTransport = {
  get: (params: IContractListParams): Promise<IContractCollection> => axios.get(`${basePath}`, { params }),
  getById: (id: number): Promise<IContract> => axios.get(`${basePath}/${id}`),
  create: (payload: ICreateContractPayload): Promise<IContract> => axios.post(`${basePath}`, payload),
  update: (payload: IUpdateContractPayload): Promise<IContract> => axios.patch(`${basePath}`, payload),
  delete: (payload: IDeleteContractPayload): Promise<IContract> => axios.delete(`${basePath}`, { data: payload }),
  getUsers: (params: IContractUserListParams): Promise<IUserShortCollection> => axios.get(`${basePath}/users`, { params }),
  createUser: (payload: ICreateContractUserPayload): Promise<IUserShort> => axios.post(`${basePath}/users`, payload),
  deleteUser: (payload: IDeleteContractUserPayload): Promise<IUserShort> => axios.delete(`${basePath}/users`, { data: payload }),
  getSyncStatus: (params: IContractSyncStatusParams): Promise<IContractSyncStatus> =>
    axios.get(`${basePath}/sync-status`, { params }),
  getGoodsSettings: (params: IContractGoodsSettingsParams): Promise<IContractGoodsSettings> =>
    axios.get(`${basePath}/goods-settings/${params.goodId}`),
  updateGoodsAvailability: (payload: IUpdateContractGoodsAvailabilityPayload): Promise<IContract> =>
    axios.patch(`${basePath}/available-goods`, payload),
  unsetGoodsSettings: (payload: IUnsetContractGoodsSettingsPayload): Promise<IContractGoodsSettings> =>
    axios.patch(`${basePath}/unset-good-settings`, payload),
  unsetManualSettings: (payload: IUnsetContractManualSettingsPayload): Promise<IContract> =>
    axios.patch(`${basePath}/unset-manually-set-goods`, payload),
};
